import Vue from 'vue';
import Router from 'vue-router';

// Login Module
import LoginForm from '_common/components/forms/LoginForm.vue';
import RecoverPassForm from '_common/components/forms/RecoverPassForm.vue';
import { fetchModulesRoutes } from '_utils';
import authMiddleware from './middlewares/authMiddleware';

// Modules
const modules = fetchModulesRoutes(require.context('_modules', true, /routes\.js$/));

const Login = () => import('@/app/views/Login.vue');
const Admin = () => import('@/app/views/Admin.vue');
const Dashboard = () => import('@/app/views/Dashboard.vue');
const UserProfileLite = () => import('_modules/settings/views/UserProfileLite.vue');

Vue.use(Router);

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      component: Login,
      redirect: '/login',
      children: [
        {
          path: 'login',
          component: LoginForm,
        },
        {
          path: 'recover-password/:token',
          component: RecoverPassForm,
        },
      ],
    },
    {
      path: '/admin',
      beforeEnter: authMiddleware,
      component: Admin,
      redirect: 'overview',
      children: [
        {
          path: 'overview',
          name: 'admin-overview',
          component: Dashboard,
        },
        {
          path: 'perfil',
          name: 'admin-perfil',
          component: UserProfileLite,
        },
        ...modules,
      ],
    },
    {
      path: '*',
      redirect: '/admin/overview/',
    },
  ],
});
